import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12765482"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-pdo-submission-new" }

import { onMounted } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useRoute } from 'vue-router';
  import { mineBreadcurmbStore } from '@/stores';
  import Submit from '@/components/offline-collection/submit.vue';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const route = useRoute();

  onMounted(async () => {
    mineBreadcurmbStore.update([
      { name: t('PDO Dashboard'), to: { name: 'pdo.programs' } },
      { name: String(route.query.title), to: { name: 'pdo.program', params: { id: route.params.id } } },
      { name: t('offline_collection.record.New Submission') }
    ]);
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Submit, { type: "PDO" })
  ]))
}
}

})